module.exports = __webpack_public_path__ + "static/img/08.2221d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/08.png
// module id = 4imf
// module chunks = 2